import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CampusUnitMessage } from '../../models/notifications/campus-unit-message.model';

@Component({
  selector: 'app-campus-unit-message-display',
  templateUrl: './campus-unit-message-display.component.html',
  styleUrls: ['./campus-unit-message-display.component.scss']
})
export class CampusUnitMessageDisplayComponent implements OnInit {

  private currentMessage: CampusUnitMessage;
  active = false;
  canSetActive = true;

  @Input() isAdmin = false;
  @Input()
  set message(message: CampusUnitMessage) {
    this.currentMessage = message;
    this.active = this.message.active;

    const currentDate = new Date();
    const messageExpireDate = new Date(message.endDate);

    if (currentDate.getTime() < messageExpireDate.getTime()) {
      this.canSetActive = false;
    }
  }
  get message(): CampusUnitMessage { return this.currentMessage; }


  @Output() onEdit = new EventEmitter<CampusUnitMessage>();
  @Output() onToggleMessageActiveState = new EventEmitter<CampusUnitMessage>();

  constructor() { }

  ngOnInit() {
  }

  edit() {
    this.onEdit.emit(this.message);
  }

  toggleActivateDeactivate() {
      this.onToggleMessageActiveState.emit(this.message);
  }

}
